import { render } from "./Dictionary2.vue?vue&type=template&id=0cda65ad&scoped=true"
import script from "./Dictionary2.vue?vue&type=script&lang=js"
export * from "./Dictionary2.vue?vue&type=script&lang=js"

import "./Dictionary2.vue?vue&type=style&index=0&id=0cda65ad&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cda65ad"]])

export default __exports__